
        var result = require("!!../../../../node_modules/css-loader/dist/cjs.js??ref--16-1!../../../../node_modules/postcss-loader/dist/cjs.js??ref--16-2!./index.shadow.css");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    